module.exports = __webpack_public_path__ + "fonts/OpenSans-Italic.3a217505.eot";